// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Curry from "../../../../../../../node_modules/rescript/lib/es6/curry.js";
import * as Config from "../../../../../../Config.bs.js";
import * as OrderStage from "../entities/OrderStage.bs.js";
import * as Belt_Option from "../../../../../../../node_modules/rescript/lib/es6/belt_Option.js";
import * as CountryConfig from "../../../../../../library/data-source/country-config/app/entity/CountryConfig.bs.js";
import * as Network$Catalyst from "../../../../../../../node_modules/@porterin/catalyst/src/helper-modules/response-handler/Network.bs.js";
import * as ApiUtils$Catalyst from "../../../../../../../node_modules/@porterin/catalyst/src/utils/ApiUtils.bs.js";
import * as TicketsRepoConfig from "./TicketsRepoConfig.bs.js";
import * as UrlUtils$Catalyst from "../../../../../../../node_modules/@porterin/catalyst/src/utils/UrlUtils.bs.js";
import * as NetworkV2$Catalyst from "../../../../../../../node_modules/@porterin/catalyst/src/helper-modules/response-handler/NetworkV2.bs.js";
import * as TicketsRequestMapper from "../entitiy-mapper/TicketsRequestMapper.bs.js";
import * as TicketsRequestEncoder from "./TicketsRequestEncoder.bs.js";
import * as UpdateTicketRequestEncoder from "./UpdateTicketRequestEncoder.bs.js";

function fetchTicketInfo(crn, country) {
  var url = Config.Env.getHostName(undefined) + ("/administrators/ticketing/new?crn=" + crn);
  return NetworkV2$Catalyst.get(url, {
                country: CountryConfig.countryToString(country)
              }, undefined, undefined, /* Include */2, undefined).then(function (result) {
              return ApiUtils$Catalyst.resolveRepoResponse(function (param) {
                          return Curry._1(TicketsRepoConfig.TicketsInfoResponseConverter.execute, result);
                        });
            });
}

function fetchTicketIssues(orderStage, country) {
  var url = Config.Env.getHostName(undefined) + ("/administrators/ticketing/issues?order_stage=" + OrderStage.toString(orderStage));
  return NetworkV2$Catalyst.get(url, {
                country: CountryConfig.countryToString(country)
              }, undefined, undefined, /* Include */2, undefined).then(function (result) {
              return ApiUtils$Catalyst.resolveRepoResponse(function (param) {
                          return Curry._1(TicketsRepoConfig.TicketsIssuesResponseConverter.execute, result);
                        });
            });
}

function fetchTicketActions(orderStage, country) {
  var url = Config.Env.getHostName(undefined) + ("/administrators/ticketing/actions?order_stage=" + OrderStage.toString(orderStage));
  return NetworkV2$Catalyst.get(url, {
                country: CountryConfig.countryToString(country)
              }, undefined, undefined, /* Include */2, undefined).then(function (result) {
              return ApiUtils$Catalyst.resolveRepoResponse(function (param) {
                          return Curry._1(TicketsRepoConfig.TicketsActionsResponseConverter.execute, result);
                        });
            });
}

function raiseTicket(ticket, country) {
  var requestUrl = Config.Env.getHostName(undefined) + "/administrators/ticketing/create_ticket_v2";
  var encodedPayload = JSON.stringify(TicketsRequestEncoder.execute(ticket));
  return Network$Catalyst.postRequestV2(requestUrl, encodedPayload, {
                country: CountryConfig.countryToString(country)
              }, undefined, undefined).then(function (result) {
              return ApiUtils$Catalyst.resolveRepoResponse(function (param) {
                          return Curry._1(TicketsRepoConfig.TicketRequestResponseConverter.execute, result);
                        });
            });
}

function fetchTickets(request, offset, country) {
  var urlParams = TicketsRequestMapper.DictEncoder.execute(request);
  Belt_Option.mapWithDefault(offset, undefined, (function (offset_str) {
          urlParams["offset"] = offset_str;
          
        }));
  var requestUrl = UrlUtils$Catalyst.createRequestURLfrmParams(Config.Env.getHostName(undefined), "/administrators/ticketing/filter_tickets", urlParams);
  return NetworkV2$Catalyst.get(requestUrl, {
                country: CountryConfig.countryToString(country)
              }, undefined, undefined, /* Include */2, undefined).then(function (result) {
              return ApiUtils$Catalyst.resolveRepoResponse(function (param) {
                          return Curry._1(TicketsRepoConfig.TicketsResponseConverter.execute, result);
                        });
            });
}

function fetchTicket(case_number, country) {
  var url = Config.Env.getHostName(undefined) + ("/administrators/ticketing/view_ticket/" + case_number);
  return NetworkV2$Catalyst.get(url, {
                country: CountryConfig.countryToString(country)
              }, undefined, undefined, /* Include */2, undefined).then(function (result) {
              return ApiUtils$Catalyst.resolveRepoResponse(function (param) {
                          return Curry._1(TicketsRepoConfig.TicketResponseConverter.execute, result);
                        });
            });
}

function updateTicket(ticket, country) {
  var requestUrl = Config.Env.getHostName(undefined) + "/administrators/ticketing/edit_ticket";
  var encodedPayload = JSON.stringify(UpdateTicketRequestEncoder.execute(ticket));
  return Network$Catalyst.postRequestV2(requestUrl, encodedPayload, {
                country: CountryConfig.countryToString(country)
              }, undefined, undefined).then(function (result) {
              return ApiUtils$Catalyst.resolveRepoResponse(function (param) {
                          return Curry._1(TicketsRepoConfig.UpdateTicketRequestResponseConverter.execute, result);
                        });
            });
}

var TicketsRepo = {
  fetchTicketInfo: fetchTicketInfo,
  fetchTicketIssues: fetchTicketIssues,
  fetchTicketActions: fetchTicketActions,
  raiseTicket: raiseTicket,
  fetchTickets: fetchTickets,
  fetchTicket: fetchTicket,
  updateTicket: updateTicket
};

export {
  TicketsRepo ,
  
}
/* Config Not a pure module */
